import { render, staticRenderFns } from "./UnderWritingQuestions.vue?vue&type=template&id=1d78f4b0"
import script from "./UnderWritingQuestions.vue?vue&type=script&lang=ts"
export * from "./UnderWritingQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports